export default __webpack_public_path__ + "static/media/6.56d66e17.jpg";